/**
 * KONCEPT — brak wsparcia backendu dla karnetów (patrz rozmowa z klientem).
 * Dopóki nie ma dedykowanej flagi konfiguracyjnej dla obiektu/asortymentu,
 * funkcję włączamy na sztywno tylko dla wskazanego facilityIds testowego.
 * Gdziekolwiek indziej sekcja karnetu jest niewidoczna, a reszta modala działa jak dotychczas.
 */
export const KARNET_TEST_FACILITY_ID = "1267";

export const isKarnetTestFacility = (facilityIds: string): boolean =>
  facilityIds?.split(",").includes(KARNET_TEST_FACILITY_ID) ?? false;

export const DEFAULT_KARNET_REPEATS = 4;

export const KARNET_MAX_HORIZON_WEEKS = 26;
